import React, {useEffect, useState, useMemo} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';

import {createSubNavigator} from '../../components/SubNavigator';
import PaymentSettings from './PaymentSettings';
import ManageSubscription from "./ManageSubscription";
import MakePayment from "./MakePayment";
import {basicStyles} from '../../styles/basic';
import OrganizationSingle from "../Organizations/OrganizationSingle";
import OrganizationsService from "../../services/OrganizationsService";
import {ORGANIZATION_TYPE_IDS} from "../../config";
import StoreFrontIndexEditNavigation from "../Organizations/StoreFrontIndexEditNavigation";
import SurveySettings from "../Organizations/SurveySettings";
import Activity from "../Organizations/Activity";
import MessageFlowSettings from "../Organizations/MessageFlowSettings";

const SubNavigator = createSubNavigator();

function AccountSettings(props) {
	const organizationId = props.route?.params?.organizationId || props.auth.organization.organization_id;
	const [organization, setOrganization] = useState({});

	useEffect(() => {
		const getData = async () => {
			if (organizationId) {
				let orgData = await OrganizationsService.getOrganization(organizationId);
				setOrganization(orgData);
			}
		};

		getData();
	}, [organizationId]);

	const adminPermissions = useMemo(() => {
		return organization
			&& (organization.organization_type_id == ORGANIZATION_TYPE_IDS.CLIENT || organization.organization_type_id == ORGANIZATION_TYPE_IDS.PARTNER)
			&& props.auth.permissions.includes('access_account_settings');
	}, [organization, props.auth.permissions]);

	return (
		<View style={basicStyles.flexScale}>
			<SubNavigator.Navigator  backBehavior="history" initialRouteName="OrganizationEdit">
				<SubNavigator.Screen
					name={'OrganizationEdit'}
					component={OrganizationSingle}
					options={{
						title: 'Company Profile',
					}}
				/>
				{
					adminPermissions ?
						<>
							<SubNavigator.Screen
								name={'StoreFrontIndexEditNavigation'}
								component={StoreFrontIndexEditNavigation}
								options={{
									title: 'Groups',
								}}
							/>
							<SubNavigator.Screen
								name={'SurveySettings'}
								component={SurveySettings}
								options={{
									title: 'Survey Settings',
								}}
							/>
							<SubNavigator.Screen
								name={'Activity'}
								component={Activity}
								options={{
									title: 'Activity',
								}}
							/>
						</>
						: null
				}
				{
					props.auth.permissions.includes('manage_subscription') && (
						<>
							<SubNavigator.Screen
								name="PaymentSettings"
								component={PaymentSettings}
								options={{
									title: 'Payment + Billing'
								}}
							/>
							<SubNavigator.Screen
								name="ManageSubscription"
								component={ManageSubscription}
								options={{
									title: 'Plans'
								}}
							/>
							<SubNavigator.Screen
								name="MakePayment"
								component={MakePayment}
								options={{
									title: 'Make a Payment'
								}}
							/>
						</>
					)
				}
				{
					parseInt(organization.organization_message_flow_active) === 1 ?
						<SubNavigator.Screen
							name="MessageFlowSettings"
							component={MessageFlowSettings}
							options={{
								title: 'Fluid Inbox Settings'
							}}
						/>
						: null
				}
			</SubNavigator.Navigator>
		</View>
	);
}

const mapStateToProps = (state) => {
	const {auth} = state;
	return {auth};
};

export default connect(mapStateToProps)(AccountSettings);
